import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from 'app/models/client.models';
import { Talonario } from 'app/models/talonario.models';
import { Voucher } from 'app/models/voucher.models';
import { Header } from 'app/models/header.models';
import { Detail } from 'app/models/detail.models';
import { ClientesService } from 'app/services/clientes.service';
import { ComprobantesService } from 'app/services/comprobantes.service';
import { ParametrosService } from 'app/services/parametros.service';
import moment from 'moment';
import { DialogComprobantesComponent } from './dialog-comprobantes/dialog-comprobantes.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-recibos',
  templateUrl: './recibos.component.html',
  styleUrls: ['./recibos.component.css']
})
export class RecibosComponent implements OnInit, AfterViewInit {
  sidebar: HTMLElement;
  typeComprobante: string;
  clienteproveedor: number;
  type = 'cobranza'
  talonario = '0001'
  numero = '00000001'
  form: FormGroup;
  typeCliente = ''
  cliente: Client;
  fechaHoy = moment().format('YYYY-MM-DD');
  fechaMax = moment().add(5, 'days').format('YYYY-MM-DD');
  comprobantes = [];
  totalRecibo = 0;
  datasource = new MatTableDataSource<any>(); 
  displayedColumns: string[] = ['comprobante', 'cuotas', 'importe'];
  
  // Propiedades para medios de pago
  tipoPago = 'efectivo';
  importePago = 0;
  mediosPago = [];
  totalPagos = 0;
  
  // Lista de métodos de pago disponibles
  metodosPagoDisponibles = [];
  selectedPaymentMethodId = null;

  // Propiedades para estados de carga y errores
  cargandoComprobantes = false;
  errorComprobantes = '';

  // Propiedades para la navegación por pestañas
  activeTab = 'datos-basicos';
  
  // Propiedades para talonarios
  talonarios: Talonario[] = [];
  talonarioSeleccionado: Talonario = null;
  
  // Propiedades para puntos de venta
  puntosVenta = [];
  puntoVentaSeleccionado = null;
  
  constructor(  
    private routerActive: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private clienteService: ClientesService,
    private comprobantesService: ComprobantesService,
    private parametrosService: ParametrosService
    ){
    this.typeComprobante = this.routerActive.snapshot.params.type;
    this.clienteproveedor = this.routerActive.snapshot.params.clienteproveedor;
    this.form = this.fb.group({
      razonsocial: ['', Validators.required],
      fecha: ['', Validators.required],
      moneda: ['pesos', Validators.required],
      puntoVenta: [''], // Removido temporalmente Validators.required
      talonario: ['', Validators.required],
      numeroTal: ['', Validators.required],
      imputarComprobante: ['no', Validators.required],
      observaciones: ['']
    })

    this.form.controls.talonario.valueChanges.subscribe(
      v => {
        this.talonario = v;
        this.actualizarTituloSidebar();
      }
    )

    this.form.controls.numeroTal.valueChanges.subscribe(
      v => {
        this.numero = v;
        this.actualizarTituloSidebar();
      }
    )
  }
  
  ngOnInit(): void {
    this.sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    this.form.controls.fecha.setValue(this.fechaHoy);
    
    // Cargar puntos de venta disponibles
    this.cargarPuntosVenta();
    
    // Cargar talonarios disponibles
    this.cargarTalonarios();
    
    // Cargar métodos de pago disponibles
    this.cargarMetodosPago();
    
    // Obtenemos los datos del cliente, que a su vez cargará los comprobantes
    this.getCliente();
    
    // No necesitamos agregar un comprobante interfaz aquí, ya que se hará después de cargar 
    // los comprobantes del cliente en cargarComprobantesCliente()
  }

  ngAfterViewInit() {
    // Inicializar eventos de navegación de pestañas
    this.setupTabNavigation();
  }

  /**
   * Configura eventos para la navegación entre pestañas
   * para el nuevo diseño sin utilizar material
   */
  setupTabNavigation() {
    setTimeout(() => {
      const tabs = document.querySelectorAll('.nav-link');
      tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          
          // Desactivar todas las pestañas
          tabs.forEach(t => t.classList.remove('active'));
          
          // Activar la pestaña clickeada
          (event.currentTarget as HTMLElement).classList.add('active');
          
          // Ocultar todos los contenidos de pestañas
          const panes = document.querySelectorAll('.tab-pane');
          panes.forEach(pane => {
            pane.classList.remove('show');
            pane.classList.remove('active');
          });
          
          // Mostrar el contenido correspondiente
          const target = (event.currentTarget as HTMLElement).getAttribute('href');
          const targetPane = document.querySelector(target);
          if (targetPane) {
            targetPane.classList.add('show');
            targetPane.classList.add('active');
          }
          
          this.activeTab = target.substring(1); // Guardar la pestaña activa
        });
      });
    }, 100);
  }

  actualizarTituloSidebar() {
    if (this.sidebar !== undefined) {
      let titulo = `${this.talonario} - ${this.numero}`;
      
      // Añadir información del cliente si está disponible
      if (this.cliente?.companyName) {
        // Limitar a 20 caracteres para evitar que el título sea demasiado largo
        const nombreCorto = this.cliente.companyName.length > 20 
          ? this.cliente.companyName.substring(0, 20) + '...'
          : this.cliente.companyName;
          
        titulo += ` | ${nombreCorto}`;
        
        // Añadir información del documento si está disponible
        if (this.cliente?.documentNumber) {
          titulo += ` (${this.cliente.documentNumber})`;
        }
      }
      
      this.sidebar.innerHTML = titulo;
    }
  }

  comprobarInput(type, cantidad: number, index: number) {
    switch (type) {
      case 'importe':
        this.comprobantes[index].importe = parseFloat(cantidad.toString());
        let total = 0;
        for (let i = 0; i < this.comprobantes.length; i++) {
          const c = this.comprobantes[i];
          total += parseFloat((c.importe || 0).toString());
        }
        this.totalRecibo = total;
        break;
    
      default:
        break;
    }
  }

  getCliente() {
    this.clienteService.getClienteById(this.clienteproveedor).subscribe(
      res => {
        this.cliente = res;
        // Determinar si es cliente o proveedor
        this.typeCliente = this.cliente?.type === 'cliente' ? 'Cliente' : 'Proveedor';
        
        // Establecer la razón social en el formulario
        if (this.cliente?.companyName) {
          this.form.controls.razonsocial.setValue(this.cliente.companyName);
        }
        
        this.form.controls.fecha.setValue(this.fechaHoy);
        this.form.controls.razonsocial.disable();
        this.form.controls.moneda.disable();
        
        // Una vez que tenemos los datos del cliente, cargamos sus comprobantes
        this.cargarComprobantesCliente();
        
        // Actualizamos el título en la barra lateral
        this.actualizarTituloSidebar();
      },
      err => {
        console.error('Error al obtener datos del cliente:', err);
        alert('Error al cargar los datos del cliente');
      }
    )
  }

  addComprobanteInterfaz() {
    this.comprobantes.push({
      id: null,
      numero: '',
      cuota: '1',
      vto: this.fechaHoy,
      saldo: 0.00,
      importe: 0.00,
      fechaEmision: this.fechaHoy
    });
    this.datasource.data = [...this.comprobantes];
  }

  cargarComprobantesCliente() {
    if (!this.cliente || !this.cliente.id) {
      this.errorComprobantes = 'No se ha seleccionado un cliente';
      console.error(this.errorComprobantes);
      return;
    }

    // Activar indicador de carga y limpiar errores previos
    this.cargandoComprobantes = true;
    this.errorComprobantes = '';

    this.comprobantesService.getComprobanteByRecibo(this.cliente.id).subscribe(
      (response) => {
        console.log('Comprobantes obtenidos del cliente:', response);
        
        // Limpiamos los comprobantes actuales
        this.comprobantes = [];
        
        // Procesamos los comprobantes recibidos
        if (Array.isArray(response) && response.length > 0) {
          // Convertimos los comprobantes al formato que necesitamos
          const comprobantesFormateados = response.map(comp => {
            console.log('Procesando comprobante:', comp);
            
            // Comprobaciones de seguridad para evitar errores
            const code = comp.voucherType?.code || 'SIN';
            const number = comp.header?.number ? comp.header.number.toString().padStart(8, '0') : '00000000';
            const numero = `${code}-${number}`;
            
            // Si detail es un array, tomamos el primer elemento, si es un objeto lo usamos directamente
            let installment = '1';
            if (Array.isArray(comp.detail) && comp.detail.length > 0) {
              installment = comp.detail[0]?.installment || '1';
            } else if (comp.detail) {
              installment = comp.detail?.installment || '1';
            }
            
            return {
              id: comp.id || 0,
              numero: numero,
              cuota: installment,
              vto: comp.header?.expirationDate || this.fechaHoy,
              saldo: comp.totalAmount || 0,
              importe: 0, // Por defecto no imputamos nada
              fechaEmision: comp.header?.dateFrom || this.fechaHoy
            };
          });
          
          // Añadimos los comprobantes a la lista
          this.comprobantes = comprobantesFormateados;
          // Creamos una nueva instancia para asegurar que se actualice la vista
          this.datasource = new MatTableDataSource(this.comprobantes);
          
          // Notificamos al usuario
          console.log(`Se encontraron ${this.comprobantes.length} comprobantes pendientes`);
        } else {
          // Si no hay comprobantes, añadimos uno vacío
          this.addComprobanteInterfaz();
          console.log('No se encontraron comprobantes pendientes para este cliente');
        }
      },
      (error) => {
        console.error('Error al obtener los comprobantes del cliente:', error);
        this.errorComprobantes = 'Error al cargar los comprobantes. Intente nuevamente.';
        // En caso de error, añadimos una línea vacía
        this.addComprobanteInterfaz();
      }
    ).add(() => {
      // Siempre se ejecuta al finalizar, independientemente de si hay éxito o error
      this.cargandoComprobantes = false;
    });
  }

  verFacturas(indice) {
    // Verificar que el cliente está cargado
    if (!this.cliente || !this.cliente.id) {
      alert('Debe seleccionar un cliente primero');
      return;
    }
    
    const dialogRef = this.dialog.open(DialogComprobantesComponent, {
      width: '60%', // Ampliamos un poco para mayor comodidad
      height: 'auto',
      panelClass: 'dialog-no-padding',
      data: {
        cliente: this.cliente.id,
        title: `COMPROBANTES PENDIENTES - ${this.typeCliente.toUpperCase()}`
      },
      disableClose: true,
      autoFocus: true,
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      console.log('Comprobante seleccionado:', result);
      if (result !== undefined) {
        // Actualizar el comprobante en la lista
        this.comprobantes[indice].id = result.id;
        this.comprobantes[indice].numero = result.numero;
        this.comprobantes[indice].cuota = result.cuota || '1';
        this.comprobantes[indice].vto = result.vto || this.fechaHoy;
        this.comprobantes[indice].fechaEmision = result.fechaEmision || this.fechaHoy;
        // Establecemos el importe sugerido igual al importe para facilitar la carga
        this.comprobantes[indice].importe = result.importe;
        
        // Recalculamos el total
        this.comprobarInput('importe', result.importe, indice);
      } 
    });
  }

  agregarPago() {
    if (this.importePago <= 0 || !this.selectedPaymentMethodId) {
      return;
    }

    // Buscar el método de pago seleccionado para obtener su nombre
    const metodoPagoSeleccionado = this.metodosPagoDisponibles.find(mp => mp.id == this.selectedPaymentMethodId);
    
    console.log('Método de pago seleccionado:', metodoPagoSeleccionado);
    console.log('ID seleccionado:', this.selectedPaymentMethodId);
    console.log('Métodos disponibles:', this.metodosPagoDisponibles);

    this.mediosPago.push({
      tipo: metodoPagoSeleccionado?.name || 'Sin especificar',
      tipoPagoId: parseInt(this.selectedPaymentMethodId),
      importe: this.importePago
    });

    this.calcularTotalPagos();
    
    // Resetear valores
    this.importePago = 0;
    this.selectedPaymentMethodId = null;
  }

  eliminarPago(index: number) {
    this.mediosPago.splice(index, 1);
    this.calcularTotalPagos();
  }

  calcularTotalPagos() {
    this.totalPagos = this.mediosPago.reduce((sum, pago) => sum + parseFloat(pago.importe), 0);
  }

  eliminarComprobante(index: number) {
    // Eliminar el comprobante de la lista
    this.comprobantes.splice(index, 1);
    
    // Actualizar el datasource para la tabla
    this.datasource.data = this.comprobantes;
    
    // Recalcular el total del recibo
    let total = 0;
    for (const comp of this.comprobantes) {
      total += parseFloat((comp.importe || 0).toString());
    }
    this.totalRecibo = total;
    
    // Permitir recibos libres - NO agregar comprobante vacío automáticamente
    // Si no quedan comprobantes, permitir continuar sin comprobantes
  }

  limpiarComprobantes() {
    // Limpiar todos los comprobantes para crear un recibo libre
    this.comprobantes = [];
    this.datasource.data = [];
    this.totalRecibo = 0;
    
    console.log('Comprobantes limpiados para recibo libre');
  }

  crearReciboLibre() {
    // Crear recibo libre - limpiar comprobantes y agregar línea de detalle libre
    this.comprobantes = [];
    this.totalRecibo = 0;
    
    // Agregar una línea de detalle libre para que el usuario pueda ingresar descripción y monto
    const detalleLibre = {
      id: null,
      numero: '', // Descripción libre del usuario
      cuota: '1',
      vto: new Date().toISOString().split('T')[0], // Fecha actual
      importe: 0,
      fechaEmision: new Date().toISOString().split('T')[0],
      esDetalleLibre: true // Flag para identificar que es detalle libre
    };
    
    this.comprobantes.push(detalleLibre);
    this.datasource.data = this.comprobantes;
    
    console.log('Recibo libre creado con línea de detalle');
  }

  tieneDetalleLibre(): boolean {
    // Verificar si algún elemento en comprobantes es un detalle libre
    return this.comprobantes && this.comprobantes.some(comp => comp.esDetalleLibre === true);
  }

  salir() {
    // Navegar hacia atrás o a la página principal de clientes
    this.router.navigate(['/clientes']);
  }

  esReciboValido(): boolean {
    // Verificar que el formulario sea válido
    if (!this.form.valid) {
      console.log('Formulario no válido:', this.form.errors);
      console.log('Estado de campos:', {
        razonsocial: this.form.get('razonsocial')?.valid,
        fecha: this.form.get('fecha')?.valid,
        moneda: this.form.get('moneda')?.valid,
        puntoVenta: this.form.get('puntoVenta')?.valid,
        talonario: this.form.get('talonario')?.valid,
        numeroTal: this.form.get('numeroTal')?.valid
      });
      return false;
    }

    // Para recibos libres: verificar que haya al menos un medio de pago
    if (this.totalPagos <= 0) {
      console.log('No hay medios de pago');
      return false;
    }

    // Verificar comprobantes y detalles libres (opcional)
    const tieneComprobantesValidos = this.comprobantes.length === 0 || this.comprobantes.some(comp => {
      if (comp.esDetalleLibre) {
        // Para detalle libre: debe tener descripción e importe
        return comp.numero && comp.numero.trim() !== '' && comp.importe > 0;
      } else {
        // Para comprobante normal: debe tener número e importe
        return comp.numero && comp.importe > 0;
      }
    });

    // PERMITIR RECIBOS SIN COMPROBANTES (solo con medios de pago)
    // Solo verificar que los pagos no excedan el total del recibo si hay comprobantes
    if (this.comprobantes.length > 0 && !tieneComprobantesValidos) {
      console.log('Comprobantes no válidos');
      return false;
    }

    if (this.comprobantes.length > 0 && this.totalPagos > this.totalRecibo) {
      console.log('Pagos exceden el total');
      return false; // Solo rechazar si los pagos exceden el total
    }

    console.log('Recibo válido');
    return true;
  }

  guardarRecibo() {
    if (!this.esReciboValido()) {
      return;
    }

    // Crear el voucher siguiendo la estructura estándar del sistema
    const voucher = new Voucher();
    const header = new Header();
    
    // ===== CONFIGURAR HEADER =====
    header.receiptBookId = parseInt(this.form.controls.talonario.value);
    header.number = parseInt(this.form.controls.numeroTal.value);
    header.dateFrom = this.form.controls.fecha.value;
    header.dateTo = this.form.controls.fecha.value;
    header.expirationDate = this.form.controls.fecha.value;
    header.receptorCuit = this.cliente?.documentNumber || null;
    header.socialReason = this.cliente?.companyName || null;
    header.address = this.cliente?.address || null;
    // Solo agregar punto de venta si está seleccionado
    if (this.form.controls.puntoVenta.value) {
      header.salesPointsId = parseInt(this.form.controls.puntoVenta.value);
    }
    
    // ===== CONFIGURAR VOUCHER =====
    voucher.type = this.typeComprobante; // 'pago' o 'cobranza'
    voucher.conceptId = 1; // ID del concepto - requerido por el backend
    voucher.currencyId = 1; // Por defecto pesos argentinos
    voucher.recordQuantity = this.comprobantes.length;
    voucher.netAmount = this.totalRecibo;
    voucher.taxableAmount = this.totalRecibo;
    voucher.ivaAmount = 0; // Requerido por el backend, 0 para recibos
    voucher.totalAmount = this.totalRecibo;
    voucher.comment = this.form.controls.observaciones.value || null;
    voucher.status = 'active';
    voucher.electronic = 0;
    voucher.sent = 0;
    voucher.currencyQuotation = 1;
    
    // ===== CONFIGURAR CLIENTE COMO OBJETO =====
    voucher.client = {
      id: this.cliente?.id,
      number: this.cliente?.number || 0,
      companyName: this.cliente?.companyName,
      documentNumber: this.cliente?.documentNumber,
      type: this.cliente?.type
    };
    
    // Asignar header al voucher
    voucher.header = header;
    
    // ===== CONFIGURAR DETAIL =====
    const details: Detail[] = [];
    
    // Procesar comprobantes (para recibos normales o detalles libres)
    this.comprobantes.forEach((comp, index) => {
      if (comp.importe > 0) {
        const detail = new Detail();
        detail.type = comp.esDetalleLibre ? 'detalle_libre' : 'comprobante_asociado';
        detail.code = comp.esDetalleLibre ? `DET-${index + 1}` : comp.numero;
        detail.description = comp.esDetalleLibre ? comp.numero : `Comprobante: ${comp.numero}`;
        detail.variantId = 0; // No aplica para recibos
        detail.quantity = 1;
        detail.unitPrice = comp.importe;
        detail.bonus = 0;
        detail.bonusAmount = 0;
        detail.subtotal = comp.importe;
        detail.subtotalWithIva = comp.importe;
        detail.batch = comp.cuota || '1';
        detail.date = comp.vto || this.form.controls.fecha.value;
        
        details.push(detail);
      }
    });
    
    voucher.detail = details;
    
    // ===== COMPROBANTES ASOCIADOS (FORMATO ESPECÍFICO DEL BACKEND) =====
    const associatedVouchers = this.comprobantes
      .filter(comp => !comp.esDetalleLibre && comp.importe > 0)
      .map(comp => ({
        id: comp.id || undefined,
        voucherNumber: comp.numero,
        voucherType: this.typeComprobante === 'pago' ? 'factura_proveedor' : 'factura_cliente',
        amount: comp.saldo || comp.importe,
        balance: comp.saldo || comp.importe,
        appliedAmount: comp.importe,
        date: comp.vto || this.form.controls.fecha.value
      }));
    
    // ===== AGREGAR ARRAYS AL VOUCHER =====
    (voucher as any).associatedVouchers = associatedVouchers.length > 0 ? associatedVouchers : null;
    
    // ===== INFORMACIÓN ADICIONAL DEL VOUCHER =====
    voucher.optionals = {
      tipoDocumento: this.typeComprobante === 'pago' ? 'orden_pago' : 'recibo',
      esReciboLibre: this.tieneDetalleLibre(),
      totalComprobantes: this.totalRecibo,
      totalPagos: this.totalPagos,
      diferencia: this.totalPagos - this.totalRecibo,
      mediosPago: this.mediosPago.map((pago) => ({
        tipoPagoId: pago.tipoPagoId,
        tipo: pago.tipo,
        importe: pago.importe
      })),
      talonarioInfo: {
        id: this.talonarioSeleccionado?.id,
        description: this.talonarioSeleccionado?.description,
        currentNumber: this.talonarioSeleccionado?.currentNumber
      },
      puntoVentaInfo: {
        id: this.puntoVentaSeleccionado?.id,
        name: this.puntoVentaSeleccionado?.name || this.puntoVentaSeleccionado?.description
      }
    };

    console.log('Voucher de recibo/orden de pago a crear:', voucher);
    
    // Guardar el voucher usando el servicio de comprobantes
    this.comprobantesService.guardarComprobante(voucher).subscribe({
      next: (response) => {
        console.log('Recibo/Orden de pago creado exitosamente:', response);
        const tipoDocumento = this.typeComprobante === 'pago' ? 'Orden de pago' : 'Recibo';
        alert(`${tipoDocumento} creado exitosamente`);
        this.router.navigate(['/clientes']);
      },
      error: (error) => {
        console.error('Error al crear el recibo/orden de pago:', error);
        const tipoDocumento = this.typeComprobante === 'pago' ? 'orden de pago' : 'recibo';
        alert(`Error al crear el ${tipoDocumento}. Por favor, intente nuevamente.`);
      }
    });
  }

  validarTotalPagos(): string {
    if (this.totalPagos === 0) {
      return '';
    }
    
    const diferencia = Math.abs(this.totalPagos - this.totalRecibo);
    if (diferencia > 0.01) {
      if (this.totalPagos > this.totalRecibo) {
        return `El total de pagos excede el importe del recibo por $ ${diferencia.toFixed(2)}`;
      } else {
        return `El total de pagos es menor que el importe del recibo por $ ${diferencia.toFixed(2)}`;
      }
    }
    
    return '';
  }

  /**
   * Carga los talonarios disponibles desde el endpoint
   */
  cargarTalonarios(): void {
    this.parametrosService.getTalonarios().subscribe({
      next: (talonarios: Talonario[]) => {
        // Filtrar solo los talonarios activos y según el tipo de operación
        this.talonarios = talonarios.filter(t => {
          const isActive = t.status === true;
          
          // Determinar el tipo de talonario según la ruta
          let isCorrectType = false;
          if (this.typeComprobante === 'pago') {
            // Para proveedores (tipo "pago"), mostrar órdenes de pago
            isCorrectType = t.description && 
              t.description.toLowerCase().includes('orden de pago');
          } else {
            // Para clientes (tipo "cobranza"), mostrar recibos y cobranzas
            isCorrectType = t.description && (
              t.description.toLowerCase().includes('recibo') ||
              t.description.toLowerCase().includes('cobranza')
            );
          }
          
          console.log('Talonario:', t.description, 'Active:', isActive, 'Type:', this.typeComprobante, 'IsCorrectType:', isCorrectType);
          return isActive && isCorrectType;
        });
        
        console.log('Talonarios filtrados para tipo', this.typeComprobante + ':', this.talonarios);
        
        // Si hay talonarios disponibles, seleccionar el primero por defecto
        if (this.talonarios.length > 0) {
          const primerTalonario = this.talonarios[0];
          this.form.controls.talonario.setValue(primerTalonario.id);
          this.onTalonarioChange({ target: { value: primerTalonario.id } } as any);
        } else {
          console.warn('No se encontraron talonarios de recibo/cobranza activos');
        }
      },
      error: (error) => {
        console.error('Error al cargar talonarios:', error);
        alert('Error al cargar los talonarios disponibles');
      }
    });
  }

  /**
   * Maneja el cambio de punto de venta seleccionado
   */
  onPuntoVentaChange(event: any): void {
    const puntoVentaId = event.target.value;
    
    if (puntoVentaId) {
      // Buscar el punto de venta seleccionado
      this.puntoVentaSeleccionado = this.puntosVenta.find(pv => pv.id == puntoVentaId);
      console.log('Punto de venta seleccionado:', this.puntoVentaSeleccionado);
    } else {
      this.puntoVentaSeleccionado = null;
    }
  }

  /**
   * Maneja el cambio de talonario seleccionado
   */
  onTalonarioChange(event: any): void {
    const talonarioId = event.target.value;
    
    if (talonarioId) {
      // Buscar el talonario seleccionado
      this.talonarioSeleccionado = this.talonarios.find(t => t.id == talonarioId);
      
      if (this.talonarioSeleccionado) {
        // Actualizar el número basado en el currentNumber del talonario
        const numeroFormateado = this.formatearNumero(this.talonarioSeleccionado.currentNumber);
        this.form.controls.numeroTal.setValue(numeroFormateado);
        
        // Actualizar las propiedades del componente
        this.talonario = this.talonarioSeleccionado.description || talonarioId.toString();
        this.numero = numeroFormateado;
        
        // Actualizar el título del sidebar
        this.actualizarTituloSidebar();
      }
    } else {
      // Si no hay talonario seleccionado, limpiar el número
      this.form.controls.numeroTal.setValue('');
      this.talonarioSeleccionado = null;
      this.numero = '';
    }
  }

  /**
   * Formatea el número del comprobante con ceros a la izquierda
   */
  private formatearNumero(numero: number): string {
    return numero.toString().padStart(8, '0');
  }

  /**
   * Carga los métodos de pago disponibles desde el endpoint
   */
  cargarMetodosPago(): void {
    this.parametrosService.getMediosPagos().subscribe({
      next: (metodosPago: any[]) => {
        // Filtrar solo los métodos de pago activos (deletedAt es null)
        this.metodosPagoDisponibles = metodosPago.filter(mp => mp.deletedAt === null);
        console.log('Métodos de pago cargados:', this.metodosPagoDisponibles);
        
        // Seleccionar el primer método de pago por defecto (si existe)
        if (this.metodosPagoDisponibles.length > 0) {
          this.selectedPaymentMethodId = this.metodosPagoDisponibles[0].id;
        }
      },
      error: (error) => {
        console.error('Error al cargar métodos de pago:', error);
        alert('Error al cargar los métodos de pago disponibles');
      }
    });
  }

  /**
   * Carga los puntos de venta disponibles desde el endpoint
   */
  cargarPuntosVenta(): void {
    this.parametrosService.getPuntosDeVenta().subscribe({
      next: (puntosVenta: any[]) => {
        // Filtrar solo los puntos de venta activos
        this.puntosVenta = puntosVenta.filter(pv => pv.status === true || pv.deletedAt === null);
        console.log('Puntos de venta cargados:', this.puntosVenta);
        
        // Seleccionar el primer punto de venta por defecto (si existe)
        if (this.puntosVenta.length > 0) {
          this.form.controls.puntoVenta.setValue(this.puntosVenta[0].id);
          this.puntoVentaSeleccionado = this.puntosVenta[0];
        }
      },
      error: (error) => {
        console.error('Error al cargar puntos de venta:', error);
        alert('Error al cargar los puntos de venta disponibles');
      }
    });
  }

}
